import React from 'react'
import { useTranslation } from 'react-i18next'
import InformationModal from '../InformationModal/InformationModal'
import TermsAndConditionsContent from '../../BetLotto/TermsAndConditions/TermsAndConditionsContent'

interface RulesModalProps {
  children: React.ReactNode
}

// We don't use this component in frontend project as this is container for mock content
const RulesModal: React.FC<RulesModalProps> = ({ children }) => {
  const { t } = useTranslation()

  return (
    <InformationModal
      title={t('lottoPage.lottoRound.rules')}
      openButton={(open) => (
        <button
          onClick={open}
          className="px-7 py-3 rounded-md text-sm font-medium transition cursor-pointer active-gradient"
        >
          {t('lottoPage.lottoRound.rules')}
        </button>
      )}
      closeButton={(close) => (
        <button
          onClick={close}
          className="px-7 py-3 rounded-md text-sm font-medium transition cursor-pointer active-gradient"
        >
          {t('message.confirm')}
        </button>
      )}
    >
      <TermsAndConditionsContent>{children}</TermsAndConditionsContent>
    </InformationModal>
  )
}

export default RulesModal
